(function() {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    
    function init() {
        const collapseTileComponents = document.querySelectorAll('.collapse-tiles-component');
        
        collapseTileComponents.forEach(component => {
            const collapses = component.querySelectorAll('.collapse-tile-content');

            const syncButtonWithCollapse = collapseEl => {
                const targetIndex = collapseEl.getAttribute('data-content-index');
                if (!targetIndex) return;

                const button = component.querySelector(`.collapse-tile-item[data-tile-index="${targetIndex}"] .collapse-tile-button`);
                if (!button) return;

                if (collapseEl.classList.contains('hide')) {
                    button.classList.remove('is-active');
                } else {
                    button.classList.add('is-active');
                }
            };

            collapses.forEach(collapseEl => {
                syncButtonWithCollapse(collapseEl);

                const collapseObserver = new MutationObserver(() => syncButtonWithCollapse(collapseEl));
                collapseObserver.observe(collapseEl, {
                    attributes: true,
                    attributeFilter: ['class']
                });
            });

            function setDesktopOrder() {
                if (window.innerWidth >= 768) {
                    const tiles = component.querySelectorAll('.collapse-tile-item');
                    const contents = component.querySelectorAll('.collapse-tile-content');
                    
                    tiles.forEach(tile => {
                        const order = tile.getAttribute('data-tile-order');
                        if (order) {
                            tile.style.setProperty('order', order, 'important');
                        }
                    });
                    
                    contents.forEach(content => {
                        const order = content.getAttribute('data-collapse-order');
                        if (order) {
                            content.style.setProperty('order', order, 'important');
                        }
                    });
                } else {
                    const allItems = component.querySelectorAll('.collapse-tile-item, .collapse-tile-content');
                    allItems.forEach(item => {
                        item.style.removeProperty('order');
                    });
                }
            }
            
            setDesktopOrder();
            
            window.addEventListener('resize', setDesktopOrder);
            
            if (window.innerWidth >= 768) {
                const observer = new MutationObserver(() => {
                    if (window.innerWidth >= 768) {
                        const tiles = component.querySelectorAll('.collapse-tile-item');
                        const contents = component.querySelectorAll('.collapse-tile-content');
                        
                        tiles.forEach(tile => {
                            const order = tile.getAttribute('data-tile-order');
                            const currentOrder = window.getComputedStyle(tile).order;
                            if (order && currentOrder !== order) {
                                tile.style.setProperty('order', order, 'important');
                            }
                        });
                        
                        contents.forEach(content => {
                            const order = content.getAttribute('data-collapse-order');
                            const currentOrder = window.getComputedStyle(content).order;
                            if (order && currentOrder !== order) {
                                content.style.setProperty('order', order, 'important');
                            }
                        });
                    }
                });
                
                observer.observe(component, {
                    attributes: true,
                    attributeFilter: ['class', 'style'],
                    subtree: true,
                    childList: true
                });
            }
 
            const toggleLinks = component.querySelectorAll('.js-collapse-trigger');
            
            toggleLinks.forEach(link => {
                link.addEventListener('click', function(e) {
                    const targetId = this.getAttribute('aria-controls');
                    const targetCollapse = document.getElementById(targetId);
                    
                    if (!targetCollapse) return;
                    
                    const isCurrentlyOpen = !targetCollapse.classList.contains('hide');
                    
                    const tileContainer = this.closest('.collapse-tile-item');
                    const currentButton = tileContainer ? tileContainer.querySelector('.collapse-tile-button') : null;
                    
                const allCollapses = component.querySelectorAll('[id^="collapse-content-"]');
                allCollapses.forEach(collapse => {
                    if (collapse.id !== targetId && !collapse.classList.contains('hide')) {
                        collapse.classList.add('hide');
                    }
                });
                
                const allButtons = component.querySelectorAll('.collapse-tile-button');
                allButtons.forEach(button => {
                    button.classList.remove('is-active');
                });
                
                setTimeout(() => {
                    const nowOpen = !targetCollapse.classList.contains('hide');
                    
                    if (currentButton) {
                        if (nowOpen) {
                            currentButton.classList.add('is-active');
                        } else {
                            currentButton.classList.remove('is-active');
                        }
                    }
                }, 10);
                    
                });
            });
        });
    }
})();

